import { AbstractControl, ValidatorFn } from '@angular/forms';
import { clean } from 'src/app/utils/numeric';

/**
 * Validate that a control value is greater than or equal to the given
 * minimum. Unlike Validators.min, it strips commas and other formatting
 * from the value before comparing, so it works with currency and other
 * formatted inputs.
 *
 * @param min The minimum value the control must be greater than or equal to.
 * @returns A validator function.
 */
export const minValueValidator = (min: number): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control || control.pristine) {
            return null
        }

        const value = clean(control.value)
        if (isNaN(value) || (value >= min)) {
            return null
        }

        return { 'minValue': { min, actual: value } }
    }
}
